import { EStatus, ILikeSchema } from '../repositories/newbuilding-card/entities/reviews/LikeSchema';

export const getNewReactionCount = (currentState: EStatus) => {
  switch (currentState) {
    case EStatus.Disliked:
      return {
        [EStatus.Disliked]: (like: ILikeSchema) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount }),
        [EStatus.Liked]: (like: ILikeSchema) => ({
          dislikesCount: Math.max(0, like.dislikesCount - 1),
          likesCount: like.likesCount + 1,
        }),
        [EStatus.Unknown]: (like: ILikeSchema) => ({
          dislikesCount: Math.max(0, like.dislikesCount - 1),
          likesCount: like.likesCount,
        }),
      };

    case EStatus.Liked:
      return {
        [EStatus.Disliked]: (like: ILikeSchema) => ({
          dislikesCount: like.dislikesCount + 1,
          likesCount: Math.max(0, like.likesCount - 1),
        }),
        [EStatus.Liked]: (like: ILikeSchema) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount }),
        [EStatus.Unknown]: (like: ILikeSchema) => ({
          dislikesCount: like.dislikesCount,
          likesCount: Math.max(0, like.likesCount - 1),
        }),
      };
    default:
      return {
        [EStatus.Disliked]: (like: ILikeSchema) => ({
          dislikesCount: like.dislikesCount + 1,
          likesCount: like.likesCount,
        }),
        [EStatus.Liked]: (like: ILikeSchema) => ({
          dislikesCount: like.dislikesCount,
          likesCount: like.likesCount + 1,
        }),
        [EStatus.Unknown]: (like: ILikeSchema) => ({ dislikesCount: like.dislikesCount, likesCount: like.likesCount }),
      };
  }
};
